// extracted by mini-css-extract-plugin
module.exports = {"list":"TableTabs_list__xSjtV","tab":"TableTabs_tab__XCajk","selected":"TableTabs_selected__W3FKO"};